import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    const body = new URLSearchParams({ email });
    await fetch('https://readdy.ai/api/form/d7d5p3ckpdh0a4advrp0', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });
    setSubscribed(true);
    setEmail('');
  };

  return (
    <footer className="bg-gradient-to-br from-rose-900 to-red-950 text-white">
      {/* Safety Assurance Banner */}
      <div className="border-b border-white/10 py-10">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-8">
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Noto Serif SC', serif" }}>安全保障 · Safety Assurance</h3>
            <p className="text-white/60 text-sm">您的安全是我们的首要承诺</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { icon: 'ri-video-line', title: '视频验证', desc: '每位会员均需完成视频身份验证' },
              { icon: 'ri-id-card-line', title: '实名认证', desc: '身份证实名认证，确保真实身份' },
              { icon: 'ri-lock-password-line', title: '隐私保护', desc: '严格的数据加密，保护您的隐私' },
              { icon: 'ri-flag-line', title: '举报系统', desc: '完善的举报机制，快速处理违规' },
            ].map((item, i) => (
              <div key={i} className="text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl mx-auto mb-3">
                  <i className={`${item.icon} text-xl text-white`}></i>
                </div>
                <h4 className="text-sm font-bold mb-1">{item.title}</h4>
                <p className="text-xs text-white/50">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg"
                alt="富缘佳旺"
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="font-bold text-base" style={{ fontFamily: "'Noto Serif SC', serif" }}>富缘佳旺</div>
                <div className="text-xs text-white/50">FortuneMatch.com</div>
              </div>
            </div>
            <p className="text-white/60 text-xs mb-5 leading-relaxed">
              真实认证，视频交友，教育为本，缘定终身。中国最值得信赖的婚恋平台。
            </p>
            {/* Newsletter */}
            <form data-readdy-form onSubmit={handleSubscribe} className="flex gap-2">
              {subscribed ? (
                <div className="text-xs text-green-400 flex items-center gap-1">
                  <i className="ri-check-line"></i> 订阅成功！
                </div>
              ) : (
                <>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="订阅最新资讯"
                    className="flex-1 bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-xs text-white placeholder-white/40 focus:outline-none focus:border-white/40"
                  />
                  <button type="submit" className="w-9 h-9 flex items-center justify-center bg-red-500 rounded-lg hover:bg-red-400 transition-all cursor-pointer flex-shrink-0">
                    <i className="ri-send-plane-line text-sm"></i>
                  </button>
                </>
              )}
            </form>
          </div>

          {/* Safety */}
          <div>
            <h5 className="font-bold text-sm mb-4">安全保障</h5>
            <ul className="flex flex-col gap-2">
              {['视频验证', '身份认证', '隐私保护', '举报系统', '安全指南'].map((item, i) => (
                <li key={i}>
                  <a href="#" className="text-white/60 text-xs hover:text-white transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h5 className="font-bold text-sm mb-4">资源中心</h5>
            <ul className="flex flex-col gap-2">
              {['情感教育中心', '成功故事', '约会技巧', '常见问题', '婚恋指南'].map((item, i) => (
                <li key={i}>
                  <a href="#" className="text-white/60 text-xs hover:text-white transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h5 className="font-bold text-sm mb-4">客户支持</h5>
            <ul className="flex flex-col gap-2">
              {['联系我们', '帮助中心', '服务条款', '隐私政策', '社区准则'].map((item, i) => (
                <li key={i}>
                  <a href="#" className="text-white/60 text-xs hover:text-white transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
            <div className="mt-5">
              <div className="text-xs text-white/60 mb-2">客服热线</div>
              <div className="text-sm font-bold">400-888-8888</div>
              <div className="text-xs text-white/40 mt-1">周一至周日 9:00-21:00</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-5">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">© 2025 FortuneMatch.com 富缘佳旺 · 版权所有</p>
          <div className="flex items-center gap-3">
            {[
              { icon: 'ri-wechat-line', label: 'WeChat' },
              { icon: 'ri-weibo-line', label: 'Weibo' },
              { icon: 'ri-facebook-line', label: 'Facebook' },
              { icon: 'ri-instagram-line', label: 'Instagram' },
            ].map((s, i) => (
              <a
                key={i}
                href="#"
                aria-label={s.label}
                className="w-8 h-8 flex items-center justify-center border border-white/20 rounded-lg text-white/60 hover:text-white hover:border-white/40 transition-all cursor-pointer"
              >
                <i className={`${s.icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <a href="#" rel="nofollow" className="text-white/40 text-xs hover:text-white/60 cursor-pointer">隐私政策</a>
        </div>
      </div>
    </footer>
  );
}
